module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 006.5059bfd5.jpg";